export const locales = ['ar', 'en']

export const defaultLocale = 'ar'

export type Lang = 'ar' | 'en'

export type Dir = 'rtl' | 'ltr'

export const toLang = (locale?: string | null): Lang => (locale === 'en' ? 'en' : 'ar')

export const toDir = (lang: Lang): Dir => (lang === 'ar' ? 'rtl' : 'ltr')

/**
 * Builds a path for the given language. Arabic (the default) has no prefix,
 * English lives under /en. Use it for server-side redirects; next/link and
 * router.push already keep the active language on their own.
 */
export const localePath = (lang: Lang, path: string): string => {
    if (lang === 'ar') return path
    return path === '/' ? '/en' : `/en${path}`
}
